import React, { createContext, useContext } from 'react';
import { useConfig } from './config-context';
export const UniqueFieldSuffixContext = /*#__PURE__*/ createContext(undefined);
export const UniqueFieldSuffixContextProvider = ({ parentId = 'id', children })=>{
    const { compId = 'comp' } = useConfig();
    const uniqueId = `${compId}-${parentId.split('-').at(0)}`;
    return /*#__PURE__*/ React.createElement(UniqueFieldSuffixContext.Provider, {
        value: uniqueId
    }, children);
};
export function useUniqueFieldSuffix() {
    const context = useContext(UniqueFieldSuffixContext);
    if (context === undefined) {
        throw new Error('useUniqueFieldSuffix must be used within a UniqueFieldSuffixContextProvider');
    }
    return context;
}

//# sourceMappingURL=unique-field-suffix-context.js.map